import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { IFloatingFilterParams, TextFilterModel } from 'ag-grid-enterprise';

export default forwardRef((props: IFloatingFilterParams, ref) => {
  const [currentValue, setCurrentValue] = useState<string | undefined>('');
  const inputRef = useRef<HTMLInputElement>(null);

  // expose AG Grid Filter Lifecycle callbacks
  useImperativeHandle(ref, () => {
    return {
      onParentModelChanged(parentModel: TextFilterModel) {
        if (!inputRef.current) return;
        // When the filter is empty we will receive a null value here
        if (!parentModel) {
          inputRef.current.value = '';
          setCurrentValue('');
        } else {
          inputRef.current.value = parentModel.filter + '';
          setCurrentValue(parentModel.filter ?? '');
        }
      },
    };
  });

  const forbiddenCharacters = ['/'];

  const onInputBoxChanged = (input: any) => {
    let val: string = input.target.value;
    if (val === '') {
      // Remove the filter
      props.parentFilterInstance((instance: any) => {
        instance.onFloatingFilterChanged(null, null);
      });
      return;
    }
    const forbiddenCharacterList = forbiddenCharacters.join('|');
    const regex = new RegExp(forbiddenCharacterList, 'g');
    val = val.replace(regex, '');

    setCurrentValue(val);
    props.parentFilterInstance((instance: any) => {
      instance.onFloatingFilterChanged('contains', val);
    });
  };

  return (
    <div className="ag-floating-filter-input" role="presentation">
      <input
        ref={inputRef}
        type="text"
        onChange={onInputBoxChanged}
        value={currentValue}
        className="ag-input-field-input ag-text-field-input"
      />
    </div>
  );
});
